import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/savedproduct';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { SavedProductInterface } from '@app/interface/savedproduct';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import { RecursiveInterface } from '@app/services/base-authenticated.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '@app/services/toast.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'izy-savedproduct-details',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    BackHeaderComponent,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    // Scheda del form come in company-detail (pannello a fisarmonica), velo di
    // caricamento e descrizione che cresce con il testo.
    MatExpansionModule,
    MatProgressSpinnerModule,
    TextFieldModule,
  ],
  templateUrl: './savedproduct-details.component.html',
  styleUrl: './savedproduct-details.component.scss',
})
export class SavedproductDetailsComponent implements OnInit {
  private toast = inject(ToastService);
  productId: number;
  productForm: FormGroup;
  isLoading = true;

  typeOptions: TypeOptions[] = [
    { code: 'SERVIZIO', name: 'Servizio' },
    { code: 'PRODOTTO', name: 'Prodotto' },
  ];

  constructor(
    private SavedProductApi: SavedProductsApi,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {
    this.productForm = this.fb.group({
      id: 1,
      // Nome e prezzo sono i campi marcati * nel markup: senza validatore il
      // form sarebbe sempre valido e il pulsante di salvataggio non mostrerebbe
      // mai lo stato disabilitato descritto nello scss.
      name: ['', Validators.required],
      units: '',
      type: 'SERVIZIO',
      unit_price: [0, Validators.required],
      description: '',
      iva_percentage: [{ value: 0, disabled: true }],

      organization_id: -1,
    });

    this.productId = +this.route.snapshot.params['id'];
  }

  ngOnInit() {
    this.loadSavedProducts();

    // Initialize filteredOptions after companies are loaded
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(300),
    //   map((value: any) => this._filter(value || ''))
    // );
  }

  private loadSavedProducts() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.SavedProductApi.getAllSavedProducts<SavedProductInterface>(
      organization_id,
      {},
    ).subscribe({
      next: (response: RecursiveInterface<SavedProductInterface>) => {
        if (response.completed) {
          const product = response.results.find((c) => c.id === this.productId);

          if (product) {
            this.productForm.patchValue({
              ...product,
              organization_id: organization_id,
            });
            this.isLoading = false;
          } else {
            // Il velo di caricamento copre la pagina finche' isLoading e' vero:
            // va abbassato anche su questo ramo, altrimenti il prodotto non
            // trovato lascerebbe la schermata bloccata sotto il velo.
            this.isLoading = false;
            throw new Error('Product not found');
          }

          console.log('All products loaded');
        } else {
          // Optional: Show loading progress
          console.log(
            `Loaded ${response.results.length} saved products so far...`,
          );
        }
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading products:', err);
        this.showErrorMessage(
          'Errore durante il caricamento prodotti e servizi.',
        );
      },
    });
  }

  onSubmit(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (this.productForm.valid) {
      this.isLoading = true;

      // where you call the update method
      this.SavedProductApi.updateSavedProductDetails(
        organization_id,
        this.productId,
        this.productForm.value,
      ).subscribe({
        next: (updatedProduct) => {
          this.isLoading = false;
          this.showSuccessMessage('Prodotto aggiornato con successo!');
          // navigate back to the list
          this.onCancel();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error updating company:', err);
          this.showErrorMessage(
            'Non è stato possibile aggiornare il prodotto.',
          );
        },
      });
    }
  }

  onCancel(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/savedproducts_table`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
